// @ts-ignore
import cheerio from 'cheerio';

export function html2Text(html: string): string {
  return cheerio.load(html).text();
}
